export const normalizedChannelsMap = {
  meetingSchedule: 'meetingSchedule',
  channel_picker: 'channel_picker',
  schedule: 'callMeLater',
  scheduledVideo: 'scheduledVideo',
  facebookMessenger: 'facebook',
  callback: 'callMeNow',
  whatsapp: 'whatsapp',
  audio: 'audio',
  video: 'video',
  chat: 'chat',
  form: 'form',
  faq: 'faq',
}
